class WysiwygExtension {
    initialize(naja)
    {
        // Immediately initialize if DOM is already loaded
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }

        // Add listeners for Naja events
        naja.addEventListener('interaction', this.init.bind(this));
        naja.addEventListener('complete', this.init.bind(this));
    }

    init(event)
    {
        $('.wysiwyg').each(function(){
            let height = Math.max(200, $(this).height() - 13);
            if ($(this).height() <= 0 && $(this).hasClass('h-100')) {
                let modal = $(this).closest('.modal');
                if (modal.length > 0) {
                    height = Math.max(200, modal.height() - 411);
                }
            }

            const isReadOnly = $(this).prop('readonly');
            const isDisabled = $(this).prop('disabled');

            $(this).summernote({
                height: height,
                toolbar: [],
                callbacks: {
                    onInit: function() {
                        $(this).next('.note-editor').find('button').attr('data-loading-indicator', 'false');

                        // Pokud je textarea readonly nebo disabled
                        if (isReadOnly || isDisabled) {
                            $(this).summernote('disable'); // Make summernote readonly
                            $(this).next('.note-editor').find('.note-editable').css('background-color', 'inherit'); // Retain original background color

                            // Přidání vizuální indikace pro disabled stav
                            if (isDisabled) {
                                // Přidat třídu pro vzhled disabled
                                $(this).next('.note-editor').addClass('disabled');
                                $(this).next('.note-editor').find('.note-editable').css({
                                    'opacity': '0.7',
                                    'cursor': 'not-allowed'
                                });
                            }
                        }
                    }
                }
            });

            // Přidáme pozorovatele mutací pro kontrolu změny atributu disabled
            const textarea = this;
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.attributeName === 'disabled') {
                        const isNowDisabled = $(textarea).prop('disabled');
                        const editor = $(textarea).next('.note-editor');

                        if (isNowDisabled) {
                            $(textarea).summernote('disable');
                            editor.addClass('disabled');
                            editor.find('.note-editable').css({
                                'background-color': 'inherit',
                                'opacity': '0.7',
                                'cursor': 'not-allowed'
                            });
                        } else {
                            $(textarea).summernote('enable');
                            editor.removeClass('disabled');
                            editor.find('.note-editable').css({
                                'opacity': '',
                                'cursor': ''
                            });
                        }
                    }
                });
            });

            observer.observe(textarea, {
                attributes: true,
                attributeFilter: ['disabled']
            });
        });
    }
}

export default WysiwygExtension;
